import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-512c34e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "社会人経験を教えてください")
], -1))
const _hoisted_4 = { class: "entry_career_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "就業状況"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_career_input_layout_column_2" }
const _hoisted_7 = { class: "entry_career_input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "経験社数"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_9 = { class: "entry_career_input_layout_column_2" }
const _hoisted_10 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_11 = { class: "entry_career_input_layout_column_2_item_inner" }
const _hoisted_12 = { class: "entry_career_input_layout_column_2_item_inner_select" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_input_layout_column_2_item_inner_suffix_text" }, "社")
], -1))
const _hoisted_14 = { class: "entry_career_input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "社会人経験年数"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_16 = { class: "entry_career_input_layout_column_2" }
const _hoisted_17 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_18 = { class: "entry_career_input_layout_column_2_item_inner" }
const _hoisted_19 = { class: "entry_career_input_layout_column_2_item_inner_select" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_input_layout_column_2_item_inner_suffix_text" }, "年")
], -1))
const _hoisted_21 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_22 = { class: "entry_career_input_layout_column_2_item_inner" }
const _hoisted_23 = { class: "entry_career_input_layout_column_2_item_inner_select" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_career_input_layout_column_2_item_inner_suffix" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_input_layout_column_2_item_inner_suffix_text" }, "ヵ月")
], -1))
const _hoisted_25 = { class: "entry_career_input" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのURL")
], -1))
const _hoisted_27 = { class: "entry_career_input_layout_column_1" }
const _hoisted_28 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_29 = { class: "entry_career_input_layout_column_1_item_inner" }
const _hoisted_30 = { class: "entry_career_input_layout_column_1_item_inner_select" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトをお持ちの方はこちらにURLを入力してください")
], -1))
const _hoisted_32 = { class: "entry_career_input" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのID")
], -1))
const _hoisted_34 = { class: "entry_career_input_layout_column_1" }
const _hoisted_35 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_36 = { class: "entry_career_input_layout_column_1_item_inner" }
const _hoisted_37 = { class: "entry_career_input_layout_column_1_item_inner_select" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトにIDが付いている場合はこちらに入力してください")
], -1))
const _hoisted_39 = { class: "entry_career_input" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "ポートフォリオサイトのパスワード")
], -1))
const _hoisted_41 = { class: "entry_career_input_layout_column_1" }
const _hoisted_42 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_43 = { class: "entry_career_input_layout_column_1_item_inner" }
const _hoisted_44 = { class: "entry_career_input_layout_column_1_item_inner_select" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "※ポートフォリオサイトにパスワードが付いている場合はこちらに入力してください")
], -1))
const _hoisted_46 = { class: "entry_career_button" }
const _hoisted_47 = { class: "entry_career_button_prev" }
const _hoisted_48 = { class: "entry_career_button_next" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { getMasterDataListWkStatus, MasterDataWkStatus } from '@/api/masterDataEndpoint';
import { getAdlandExpRegist, postAdlandExpRegist } from '@/api/careersheetEndpoint';
import store from '@/store';
import Indicator from '@/components/Indicator.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Loading from '@/components/Loading.vue';
import { validationRuleHelper } from '@/utils/validationRule';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeView',
  setup(__props) {

const wkStatusList = ref<MasterDataWkStatus[]>([]);
const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    const [resMasterDataListWkStatus, resAdlandExpRegist] = await Promise.all([getMasterDataListWkStatus(), getAdlandExpRegist()]);
    wkStatusList.value = resMasterDataListWkStatus;
    wkStatusId.value = resAdlandExpRegist.wkStatusId ? resAdlandExpRegist.wkStatusId : '';
    expcompNum.value = resAdlandExpRegist.expcompNum !== null ? resAdlandExpRegist.expcompNum.toString() : '';
    expYearNum.value = resAdlandExpRegist.expYearNum !== null ? resAdlandExpRegist.expYearNum.toString() : '';
    expMonthNum.value = resAdlandExpRegist.expMonthNum !== null ? resAdlandExpRegist.expMonthNum.toString() : '';
    portfolioSiteUrl.value = resAdlandExpRegist.portfolioSiteUrl !== null ? resAdlandExpRegist.portfolioSiteUrl.toString() : '';
    portfolioSiteId.value = resAdlandExpRegist.portfolioSiteId !== null ? resAdlandExpRegist.portfolioSiteId.toString() : '';
    portfolioSitePass.value = resAdlandExpRegist.portfolioSitePass !== null ? resAdlandExpRegist.portfolioSitePass.toString() : '';
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const { meta } = useForm();

const { value: wkStatusId, errors: wkStatusIdErrors } = useField<string | null>('wkStatusId', validationRuleHelper({ required: true }), {
  initialValue: '',
  bails: false,
  label: '就業状況',
});

const { value: expcompNum, errors: expcompNumErrors } = useField<string>(
  'expcompNum',
  validationRuleHelper({ required: true, numeric: true }),
  {
    initialValue: '',
    bails: false,
    label: '経験社数',
  }
);

const { value: expYearNum, errors: expYearNumErrors } = useField<string>(
  'expYearNum',
  validationRuleHelper({ required: true, betweenValue: [0, 99] }),
  {
    initialValue: '',
    bails: false,
    label: '経験年数（年）',
  }
);
const { value: expMonthNum, errors: expMonthNumErrors } = useField<string>(
  'expMonthNum',
  validationRuleHelper({ required: true, betweenValue: [0, 12] }),
  {
    initialValue: '',
    bails: false,
    label: '経験年数（月）',
  }
);

const { value: portfolioSiteUrl, errors: portfolioSiteUrlErrors } = useField<string | null>('portfolioSiteUrl', validationRuleHelper({ han_eisuu_kigou: true,max: 200 }), {
  initialValue: '',
  bails: false,
  label: 'ポートフォリオサイトのURL',
});

const { value: portfolioSiteId, errors: portfolioSiteIdErrors } = useField<string | null>('portfolioSiteId', validationRuleHelper({ han_eisuu_kigou: true,max: 20 }), {
  initialValue: '',
  bails: false,
  label: 'ポートフォリオサイトのID',
});

const { value: portfolioSitePass, errors: portfolioSitePassErrors } = useField<string | null>('portfolioSitePass', validationRuleHelper({ han_eisuu_kigou: true,max: 20 }), {
  initialValue: '',
  bails: false,
  label: 'ポートフォリオサイトのパスワード',
});


const expYearExpMonthErrors = computed(() => {
  const err = [];
  if (expYearNumErrors.value) {
    err.push(expYearNumErrors.value);
  }
  if (expMonthNumErrors.value) {
    err.push(expMonthNumErrors.value);
  }
  return err.flat();
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c01' });
};

const submitAndTransitionNextPage = async () => {
  isLoading.value = true;
  try {
    await postAdlandExpRegist({
      wkStatusId: Number(wkStatusId.value),
      expcompNum: Number(expcompNum.value),
      expYearNum: Number(expYearNum.value),
      expMonthNum: Number(expMonthNum.value),
      portfolioSiteUrl: portfolioSiteUrl.value,
      portfolioSiteId: portfolioSiteId.value,
      portfolioSitePass: portfolioSitePass.value,
    });
    store.commit('entryCareerCompany/setEditingBusicrId', 1);
    await store.dispatch('entryCareerCompany/getWorkHistoryDetailInfo', 1);
    router.push({ name: 'c03' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 3,
          max: 12
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wkStatusList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.code,
              class: "entry_career_input_layout_column_2_item"
            }, [
              _createVNode(BaseRadioButton, {
                modelValue: _unref(wkStatusId),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wkStatusId) ? (wkStatusId).value = $event : null)),
                value: item.code,
                name: "english",
                label: item.name
              }, null, 8, ["modelValue", "value", "label"])
            ]))
          }), 128)),
          (_unref(wkStatusIdErrors))
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 0,
                errors: _unref(wkStatusIdErrors)
              }, null, 8, ["errors"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(BaseTextForm, {
                  modelValue: _unref(expcompNum),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(expcompNum) ? (expcompNum).value = $event : null)),
                  placeholder: "2",
                  maxlength: 2,
                  isError: !!_unref(expcompNumErrors).length
                }, null, 8, ["modelValue", "isError"])
              ]),
              _hoisted_13
            ])
          ])
        ]),
        (_unref(expcompNumErrors))
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: _unref(expcompNumErrors)
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(BaseTextForm, {
                  modelValue: _unref(expYearNum),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(expYearNum) ? (expYearNum).value = $event : null)),
                  placeholder: "6",
                  maxlength: 2,
                  isError: !!_unref(expYearNumErrors).length
                }, null, 8, ["modelValue", "isError"])
              ]),
              _hoisted_20
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(BaseTextForm, {
                  modelValue: _unref(expMonthNum),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(expMonthNum) ? (expMonthNum).value = $event : null)),
                  placeholder: "6",
                  maxlength: 2,
                  isError: !!_unref(expMonthNumErrors).length
                }, null, 8, ["modelValue", "isError"])
              ]),
              _hoisted_24
            ])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(expYearExpMonthErrors) }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(BaseTextForm, {
                  maxlength: 200,
                  modelValue: _unref(portfolioSiteUrl),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(portfolioSiteUrl) ? (portfolioSiteUrl).value = $event : null)),
                  isError: !!_unref(portfolioSiteUrlErrors).length
                }, null, 8, ["modelValue", "isError"])
              ])
            ])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(portfolioSiteUrlErrors) }, null, 8, ["errors"])
      ]),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(BaseTextForm, {
                  maxlength: 200,
                  modelValue: _unref(portfolioSiteId),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(portfolioSiteId) ? (portfolioSiteId).value = $event : null)),
                  isError: !!_unref(portfolioSiteIdErrors).length
                }, null, 8, ["modelValue", "isError"])
              ])
            ])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(portfolioSiteIdErrors) }, null, 8, ["errors"])
      ]),
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(BaseTextForm, {
                  maxlength: 200,
                  modelValue: _unref(portfolioSitePass),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(portfolioSitePass) ? (portfolioSitePass).value = $event : null)),
                  isError: !!_unref(portfolioSitePassErrors).length
                }, null, 8, ["modelValue", "isError"])
              ])
            ])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(portfolioSitePassErrors) }, null, 8, ["errors"])
      ]),
      _hoisted_45,
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(BaseButton, {
            onClick: submitAndTransitionNextPage,
            theme: "primary",
            type: "button",
            disabled: _unref(meta).valid && _unref(meta).dirty ? false : true
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存して次へ ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})